// extracted by mini-css-extract-plugin
export default {"embedVideo":"Iframe_embedVideo__-rjOl","embedYoutube":"Iframe_embedYoutube__KXMAJ"};